import ClientGroupModel    from '@models/shop/ClientGroupModel';
import ProductPricingModel from '@models/shop/ProductPricingModel';
import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import ShopServiceModel    from '@/models/ShopServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';
import CurrencyModel       from '@models/shop/CurrencyModel';

@model.urnResource('product_pricing_client_group')
@doc.path('/product_pricing_client_groups/{?id}')
export default class ProductPricingClientGroupModel extends Blamable(TimestampAble(ShopServiceModel)) {
	private declare _tsFilters: {
		'clientGroup': id;
		'clientGroup.reference': Shop_ClientGroupReference;
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'priceInclTax[between]': string;
		'priceInclTax[gt]': string;
		'priceInclTax[gte]': string;
		'priceInclTax[lt]': string;
		'priceInclTax[lte]': string;
		'productPricing': id;
		'productPricing.productVariant': id;
		'productPricing.productVariant.product': id;
		'productPricing.productVariant.product.entertainment': id;
		'productPricing.productVariant.product.entertainment.entertainmentUrn': Urn;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'priceInclTax': string;
		'updatedAt': string;
	};	

	@doc.model(ClientGroupModel) declare clientGroup: ClientGroupModel;
	@doc.model(CurrencyModel) declare currency: CurrencyModel;
	@doc.number declare priceInclTax: number;
	@doc.model(ProductPricingModel) declare productPricing: ProductPricingModel;

}